export default __webpack_public_path__ + "static/media/ShoppingCart.eca5ee08.png";